import { useState } from "react";
import { toast } from "sonner";
import { Link2, Mail, Check } from "lucide-react";

export default function ShareJob({ job }) {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Could not copy link");
    }
  };

  const subject = encodeURIComponent(`Job opportunity at AMVI Technologies: ${job.role}`);
  const body = encodeURIComponent(
    `I thought you might be interested in this role at AMVI Technologies:\n\n${job.role} (${job.type}) — ${job.location}\n\n${job.summary}\n\nView & apply: ${url}`
  );

  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="share-job">
      <span className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">Share</span>
      <button
        type="button"
        onClick={copyLink}
        className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-sm text-slate-200 transition-colors hover:border-sky-400/50 hover:text-white"
        data-testid="share-copy-link"
      >
        {copied ? <Check className="h-4 w-4 text-sky-400" /> : <Link2 className="h-4 w-4" />}
        {copied ? "Copied" : "Copy Link"}
      </button>
      <a
        href={`mailto:?subject=${subject}&body=${body}`}
        className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-sm text-slate-200 transition-colors hover:border-sky-400/50 hover:text-white"
        data-testid="share-email"
      >
        <Mail className="h-4 w-4" /> Email This Job
      </a>
    </div>
  );
}
